import React, { Component } from "react";

import { withTimerangeIntelligence } from "../../../shared/containers/containerTimerangeIntelligence";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { withPositions } from "../../../shared/containers/containerPositions";

import Notification from "./../../../shared/items/static/notification";
import Preloader from "./../../../shared/items/static/preloader";
import messages from "./../../../shared/static.messages";
import { states } from "../../../reducers/queriesStates";
import styles from "./intelligenceGeneralData.module.scss";

import Dashboards from "../../Dashboards/Dashboards";
import CookieService from "../../../shared/services/cookiesService";
import configuration from "./../../../config.json";

class IntelligenceGeneralData extends Component {
  constructor(props) {
    super(props);

    this.getGeneralData = this.getGeneralData.bind(this);
    this.state = {
      vehicleReport: null,
    };
  }

  componentDidMount() {
    const { timerangeIntelligenceState, positionsDataState, onGetReportsList, reportsListDataState } = this.props;
    const { vehicleReport } = this.state;

    if (vehicleReport === null) {
      if (reportsListDataState !== states.READY) {
        onGetReportsList();
      } else {
        this.setVehicleReport();
      }
    }

    if (timerangeIntelligenceState === states.REQUEST && positionsDataState !== states.REQUEST) {
      this.getGeneralData();
    }

    if (timerangeIntelligenceState === states.READY && positionsDataState !== states.READY) {
      this.getGeneralData();
    }

    if (timerangeIntelligenceState === states.FAILURE && positionsDataState !== states.READY) {
      this.getGeneralData();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      timerangeIntelligenceState,
      carId,
      startDate,
      endDate,
      positionsDataState,
      onGetPositions,
      onSetTimeRangeIntelligenceReady,
      onSetTimeRangeIntelligenceFailure,
      positionsCount,
      reportsListDataState,
    } = this.props;

    if (prevProps.reportsListDataState === states.REQUEST && reportsListDataState === states.READY) {
      const vehicleReport = this.setVehicleReport();

      if (positionsDataState !== states.READY) {
        onGetPositions(
          {
            carId,
            startDate,
            endDate,
          },
          vehicleReport
        );
      }
    }

    if (timerangeIntelligenceState === states.REQUEST && prevProps.timerangeIntelligenceState !== states.REQUEST) {
      this.getGeneralData();
    }

    if (positionsDataState === states.READY && prevProps.positionsDataState === states.REQUEST) {
      if (timerangeIntelligenceState === states.REQUEST) {
        onSetTimeRangeIntelligenceReady();
      }
    }

    if (positionsDataState === states.FAILURE && prevProps.positionsDataState === states.REQUEST) {
      if (timerangeIntelligenceState === states.REQUEST) {
        onSetTimeRangeIntelligenceFailure();
      }
    }

    if (positionsDataState === states.READY && prevProps.positionsDataState === states.REQUEST && positionsCount === 0) {
      if (timerangeIntelligenceState === states.REQUEST) {
        onSetTimeRangeIntelligenceFailure();
      }
    }
  }

  setVehicleReport() {
    const { reportsListData } = this.props;

    const authData = JSON.parse(CookieService.getCookie(configuration.cookieName));
    const vehicleReports = !!localStorage.getItem(configuration.vehicleReports)
      ? JSON.parse(localStorage.getItem(configuration.vehicleReports))
      : [];

    const customVehicleReport = vehicleReports.filter((x) => {
      return x.email === authData.email;
    })[0];

    const vehicleReport = reportsListData.filter((item) => {
      if (customVehicleReport !== undefined && customVehicleReport.id !== null) {
        if (item.id === customVehicleReport.id) {
          return true;
        }
      }

      return item.patternReport !== undefined && item.patternReport !== null && item.buildType === 0;
    })[0];

    this.setState({ vehicleReport });

    return vehicleReport;
  }

  getGeneralData() {
    const { carId, startDate, endDate, onGetPositions, reportsListDataState, onGetReportsList } = this.props;

    if (reportsListDataState === states.READY) {
      const { vehicleReport } = this.state;

      onGetPositions(
        {
          carId,
          startDate,
          endDate,
        },
        vehicleReport ?? this.setVehicleReport()
      );
    }

    if (reportsListDataState !== states.READY) {
      onGetReportsList();
    }
  }

  render() {
    const { positionsDataState, positionsTableData, positionsData, generalDataState, onSetGeneralDataState } = this.props;
    const { vehicleReport } = this.state;

    if (vehicleReport === null) {
      return (
        <div className={styles.intelligenceGeneralData}>
          <div className={styles.container_preloader}>
            <Preloader />
          </div>
        </div>
      );
    }

    return (
      <div className={styles.intelligenceGeneralData}>
        {positionsDataState === states.READY && positionsTableData.days.length > 0 ? (
          <Dashboards
            dataState={generalDataState}
            vehicleReport={vehicleReport}
            positionsData={positionsData}
            onSetDataState={onSetGeneralDataState}
          />
        ) : positionsDataState === states.READY && positionsTableData.days.length === 0 ? (
          <Notification type="warning">
            <p>{messages.noData}</p>
          </Notification>
        ) : positionsDataState === states.FAILURE ? (
          <Notification type="error">
            <p>{messages.error}</p>
          </Notification>
        ) : positionsDataState === states.REQUEST ? (
          <div className={styles.container_preloader}>
            <Preloader />
          </div>
        ) : null}
      </div>
    );
  }
}

export default withPositions(withReportsList(withTimerangeIntelligence(IntelligenceGeneralData)));
